module.exports = __webpack_public_path__ + "static/channel-magazine-2d37d751a3ddb9324c2e4e771280f179.png";